/* eslint-disable indent */
import {
    CREATE_FEED_POST,
    GET_FEEDS_RESULTS,
    CREATE_COMMENT_POST,
    DELETE_FEEDS_CATEGORY
} from "../actionTypes";  

const initialState = {
  get_feed_result: []
};
 
export default (state = initialState, { type, payload }) => {
    switch (type) {
        case CREATE_FEED_POST: {
          return {
            ...state,
            get_feed_result: {
              ...state.get_feed_result,
              get_feed_result: payload.user ? 
                [payload, ...(state.get_feed_result?.get_feed_result || [])] :
                state.get_feed_result?.get_feed_result || []
            }
          };
        }

        case CREATE_COMMENT_POST: {
          return {
            ...state,
            get_feed_result: {
              ...state.get_feed_result,
              get_feed_result: state.get_feed_result?.get_feed_result?.map(post =>
                post.id === payload.feed_id
                  ? { ...post, comments: [...post.comments, payload] }
                  : post
              ) || []
            }
          };
        }

        case DELETE_FEEDS_CATEGORY: {
          return {
            ...state,
            get_feed_result: {
              ...state.get_feed_result,
              get_feed_result: state.get_feed_result?.get_feed_result?.filter(
                post => post.id !== payload.id
              ) || []
            }
          };
        }

        case GET_FEEDS_RESULTS:
          return {
            ...state,
            get_feed_result: payload
          };

        default:
          return state;
    }
};

   